<template>
  <div style="width: 100%;height: 100%;padding: 20px;box-sizing: border-box;background-color: white">
    <div style="height: 50px">
      <el-date-picker v-fixZoom v-model="sendTime" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
      </el-date-picker>
      <el-button type="primary" @click="searchQuery">查询</el-button>
    </div>
    <div style="height: calc(100% - 100px);overflow-y: auto">
      <el-table v-loading="loading" height="100%" element-loading-text="加载中，请耐心等待。" :data="tableData" border style="width: 100%" highlight-current-row ref="singleTable">
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column label="订单号" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.orderid}}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务对象" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.person_name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务内容" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.service_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务提供商" min-width="100" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.supplier_name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务人员" min-width="100" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.supplier_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="start_svs_tm" label="开始时间" min-width="110" align="center"></el-table-column>
        <el-table-column prop="" label="完成时长" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{getTimeShow(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="完成备注" min-width="110" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="serviceDetails(scope.row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="openShow" v-if="openShow"
               width="900px" :show-close="true" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div><strong>{{titleShow}}</strong></div>
        <div class="line-title"></div>
      </div>
      <order-details :orderObj="orderObj" v-model="openShow" @changeTable="searchQuery"></order-details>
    </el-dialog>
  </div>
</template>
<script>
import orderDetails from './childComponents/orderDetails.vue'
import {querypersonsupplierservicecheckinfo} from '../../api/serviceMark'
export default {
  name: 'examineOrder',
  components: {orderDetails},
  data () {
    return {
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      sendTime: [],
      openShow: false,
      titleShow: '审核服务单',
      orderObj: {
        row: ''
      }
    }
  },
  created () {
    this.getTableOrder()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableOrder()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableOrder()
    },
    searchQuery () {
      this.currentPage = 1
      this.getTableOrder()
    },
    getTableOrder () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        start_time: this.sendTime[0] ? this.sendTime[0] + ' 00:00:00' : '',
        end_time: this.sendTime[1] ? this.sendTime[1] + ' 23:59:59' : '',
        pss_id: 0,
        pid: 0
      }
      querypersonsupplierservicecheckinfo(params, data).then(res => {
        this.tableData = res.data.records
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    getTimeShow (obj) {
      let tmShow1 = ''
      if (obj.start_svs_tm !== '0000-00-00 00:00:00' && obj.svs_tm !== '0000-00-00 00:00:00') {
        tmShow1 = this.util.getTimeDifference(obj.start_svs_tm, obj.svs_tm)
      }
      return tmShow1
    },
    serviceDetails (row) {
      this.titleShow = '服务单详情'
      this.orderObj.row = row
      this.openShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/examineOrder.vue